import React, { Fragment, useState} from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { populateActions } from '../../../utils/calculations';
import { skills } from '../../../resources/skills';

import Modal from 'react-modal';
import AttackModal from '../modals/AttackModal';

import { saveCharacter } from '../../../actions/character';

const CharEditActions = ({
    character: {
        character
    },
    saveCharacter
}) => {

    const {
        armorLevel,
        armorExpertise,
        assaultWeaponLevel,
        assaultWeaponExpertise,
        astrobiologyLevel,
        astrobiologyExpertise,
        athleticsLevel,
        athleticsExpertise,
        bladeLevel,
        bladeExpertise,
        bluntLevel,
        bluntExpertise,
        energyLevel,
        energyExpertise,
        espionageLevel,
        espionageExpertise,
        explosivesLevel,
        explosivesExpertise,
        fluidLevel,
        fluidExpertise,
        gravLevel,
        gravExpertise,
        longRangeLevel,
        longRangeExpertise,
        negotiationLevel,
        negotiationExpertise,
        observationLevel,
        observationExpertise,
        pistolLevel,
        pistolExpertise,
        psycheLevel,
        psycheExpertise,
        techLevel,
        techExpertise,
        unarmedLevel,
        unarmedExpertise,
        vehiclesLevel,
        vehiclesExpertise,
        waveLevel,
        waveExpertise,
        inventory,
        vehicles
    } = character;

    let charPropArray = Object.keys(character);
    charPropArray = charPropArray.slice(charPropArray.length - 60);

    const levelArray = [
        armorLevel,
        assaultWeaponLevel,
        astrobiologyLevel,
        athleticsLevel,
        bladeLevel,
        bluntLevel,
        energyLevel,
        espionageLevel,
        explosivesLevel,
        fluidLevel,
        gravLevel,
        longRangeLevel,
        negotiationLevel,
        observationLevel,
        pistolLevel,
        psycheLevel,
        techLevel,
        unarmedLevel,
        vehiclesLevel,
        waveLevel,
    ];

    const expertiseArray = [
        armorExpertise,
        assaultWeaponExpertise,
        astrobiologyExpertise,
        athleticsExpertise,
        bladeExpertise,
        bluntExpertise,
        energyExpertise,
        espionageExpertise,
        explosivesExpertise,
        fluidExpertise,
        gravExpertise,
        longRangeExpertise,
        negotiationExpertise,
        observationExpertise,
        pistolExpertise,
        psycheExpertise,
        techExpertise,
        unarmedExpertise,
        vehiclesExpertise,
        waveExpertise
    ];

    var [showMainAttackModal, toggleMainAttackModal] = useState(false);
    var [showOffhandAttackModal, toggleOffhandAttackModal] = useState(false);
    var [showVehicleAttackModal1, toggleVehicleAttackModal1] = useState(false);
    var [showVehicleAttackModal2, toggleVehicleAttackModal2] = useState(false);

    const openMainAttackModal = (e) => {
        toggleMainAttackModal(true);
    }

    const openOffhandAttackModal = (e) => {
        toggleOffhandAttackModal(true);
    }

    const openVehicleAttackModal1 = (e) => {
        toggleVehicleAttackModal1(true);
    }

    const openVehicleAttackModal2 = (e) => {
        toggleVehicleAttackModal2(true);
    }

    const closeModals = (e) => {
        toggleMainAttackModal(false);
        toggleOffhandAttackModal(false);
        toggleVehicleAttackModal1(false);
        toggleVehicleAttackModal2(false);
    }

    // Get an array of mods which add actions
    var moddedItems = inventory.filter(x => x.equippedMods.length > 0);
    var actionModArray = [];

    if(moddedItems.length > 0){

        for(var i = 0; i < moddedItems.length; i++){
            for(var j = 0; j < moddedItems[i].equippedMods.length; j++){
                actionModArray.push(moddedItems[i].equippedMods[j]);
            }
        }

        actionModArray.filter(x => x.effectTarget === "Action");
    }

    const allActions = populateActions(skills, levelArray, expertiseArray, actionModArray);

    var charGloves;
    var charMainHand;
    var charOffHand;

    var curVehicle;
    var vehicleWeap1;
    var vehicleWeap2;

    var mainHandAttackType;
    var offHandAttackType;
    var vehicleAttackType1;
    var vehicleAttackType2;

    if (inventory != undefined) {

        charGloves = inventory.find(x => x.equipped === "Hands");
        charMainHand = inventory.find(x => x.equipped === "Main Hand");
        charOffHand = inventory.find(x => x.equipped === "Off Hand");

        curVehicle = vehicles.find(x => x.currentlyEntered === true);
        if( curVehicle !== undefined){
            vehicleWeap1 = curVehicle.weapons[0];
            vehicleWeap2 = curVehicle.weapons[1];

            if( vehicleWeap1 !== undefined ){
                if(vehicleWeap1.type === "Blade" || vehicleWeap1.type === "Blunt"){
                vehicleAttackType1 = "Melee";
                } else if(vehicleWeap1.type === "Assault Weapon" || vehicleWeap1.type === "Long Range" || vehicleWeap1.type === "Pistol"){
                    vehicleAttackType1 = "Ranged";
                }
            }
            
            if( vehicleWeap2 !== undefined ){
                if(vehicleWeap2.type === "Blade" || vehicleWeap2.type === "Blunt"){
                    vehicleAttackType2 = "Melee";
                } else if(vehicleWeap2.type === "Assault Weapon" || vehicleWeap2.type === "Long Range" || vehicleWeap2.type === "Pistol"){
                    vehicleAttackType2 = "Ranged";
                }
            }
        }
        

        //If we have nothing equipped in main hand, only option is to perform an unarmed attack with main hand
        if(charMainHand === undefined){
            mainHandAttackType = "Unarmed";

            //We may have something in our offhand which could also be used for an attack at this point
            if(charOffHand !== undefined){
                //We have something equipped in our offhand, if it's blade or blunt do melee attack, otherwise do ranged attack
                if(charOffHand.type === "Blade" || charOffHand.type === "Blunt"){
                    offHandAttackType = "Melee";
                } else {
                    offHandAttackType = "Ranged";
                }
            }
        } else {

            //We have something equipped in main hand. If it is blade or blunt, do melee attack, otherwise do ranged
            if(charMainHand.type === "Blade" || charMainHand.type === "Blunt"){
                mainHandAttackType = "Melee";
            } else {
                mainHandAttackType = "Ranged";
            }

            //We may have the option to attack with offhand instead. If nothing is equipped in offhand AND if we're not wielding a two-handed weapon, we can do an off-hand unarmed attack
            if(charOffHand === undefined){
                
                if(charMainHand.type !== "Assault Weapon" && charMainHand.type !== "Long Range"){
                    // *** Need to check two-handed melee weapons here eventually ***
                    offHandAttackType = "Unarmed";
                }
            } else {
                //We have something equipped in our offhand, if it's blade or blunt do melee attack, otherwise do ranged attack
                if(charOffHand.type === "Blade" || charOffHand.type === "Blunt"){
                    offHandAttackType = "Melee";
                } else {
                    offHandAttackType = "Ranged";
                }
            }
        }
    }

    const reloadWeapon = (weapon) => e => {
        var magCount = character.inventory.filter(x => x.name === "Gun Magazine").length

        if(magCount > 0){
            var charWeap = character.inventory.find(x => x === weapon);

            charWeap.currentAmmo = charWeap.magSize;

            var newCharInv = [...character.inventory, charWeap];

            saveCharacter({
                ...character,
                "inventory": newCharInv
            });
        } else {
            alert("You are out of gun magazines!");
        }
        
    }

    return ( 
        <Fragment>
            <div className="char-sheet-actions-panel">
                <Modal
                    isOpen={showMainAttackModal}
                    onRequestClose={closeModals}
                    className="attackModal"
                    overlayClassName="attackOverlay"
                >
                    <AttackModal closeModal={closeModals} attackType={mainHandAttackType} attackSource="Main Hand" />
                </Modal>
                <Modal
                    isOpen={showOffhandAttackModal}
                    onRequestClose={closeModals}
                    className="attackModal"
                    overlayClassName="attackOverlay"
                >
                    <AttackModal closeModal={closeModals} attackType={offHandAttackType} attackSource="Off Hand" />
                </Modal>
                <Modal
                    isOpen={showVehicleAttackModal1}
                    onRequestClose={closeModals}
                    className="attackModal"
                    overlayClassName="attackOverlay"
                >
                    <AttackModal closeModal={closeModals} attackType={vehicleAttackType1} attackSource="Vehicle Weapon 1" />
                </Modal>

                <Modal
                    isOpen={showVehicleAttackModal2}
                    onRequestClose={closeModals}
                    className="attackModal"
                    overlayClassName="attackOverlay"
                >
                    <AttackModal closeModal={closeModals} attackType={vehicleAttackType2} attackSource="Vehicle Weapon 2" />
                </Modal>

                <h2 className='mary-1'>Equipped Weapons</h2>
                
                {charMainHand !== undefined ? (
                    <div className="weaponListItem">
                        <div className="hand">Main Hand</div>
                        <div className="equipContainer">
                            <h2>{charMainHand.name}</h2>
                            <div>
                                <p>Num Dice: <span>{charMainHand.numDice}</span></p>
                                <p>Dice Size: <span>d{charMainHand.diceSize}</span></p>
                            </div>
                            <div>
                                {(charMainHand.type !== "Blade" && charMainHand.type !== "Blunt") &&
                                    <div>
                                        <p>Range: <span>{charMainHand.range}m</span></p>
                                        <p>Ammo: <span>{charMainHand.currentAmmo} / {charMainHand.magSize}</span></p>
                                    </div>
                                }
                            </div>
                            <div className="weapButContainer">
                                {(charMainHand.type !== "Blade" && charMainHand.type !== "Blunt" && charMainHand.currentAmmo < charMainHand.magSize)  &&
                                    <div className="bg-med1" onClick={e => reloadWeapon(charMainHand)(e)}>RELOAD</div>
                                }
                                <div className="bg-med2" onClick={openMainAttackModal}>ATTACK</div>
                            </div>
                        </div>
                    </div>
                ) : charGloves != undefined ? (
                    <div className="weaponListItem">
                        <div className="hand">Gloves</div>
                        <div className="equipContainer">
                            <h2>{charGloves.name}</h2>
                            <div>
                                <p>Num Dice: <span>{charGloves.numDice}</span></p>
                                <p>Dice Size: <span>d{charGloves.diceSize}</span></p>
                            </div>
                            <div className="weapButContainer">
                                <div className="bg-med2" onClick={openMainAttackModal}>ATTACK</div>
                            </div>
                        </div>
                        
                    </div>
                ) : (
                    <div className="weaponListItem">
                        <div className="hand">Gloves</div>
                        <div className="equipContainer">
                            <h2>Bare Hand</h2>
                            <div>
                                <p>Num Dice: <span>1</span></p>
                                <p>Dice Size: <span>d4</span></p>
                            </div>
                            <div className="weapButContainer">
                                <div className="bg-med2" onClick={openMainAttackModal}>ATTACK</div>
                            </div>
                        </div>
                        
                    </div>
                )
                }

                {offHandAttackType !== undefined && offHandAttackType !== "Unarmed" ? (
                    <div className="weaponListItem">
                        <div className="hand">Off Hand</div>
                        <div className="equipContainer">
                            <h2>{charOffHand.name}</h2>
                            <div>
                                <p>Num Dice: <span>{charOffHand.numDice}</span></p>
                                <p>Dice Size: <span>d{charOffHand.diceSize}</span></p>
                            </div>
                            <div>
                                {(charOffHand.type !== "Blade" && charOffHand.type !== "Blunt") &&
                                    <div>
                                        <p>Range: <span>{charOffHand.range}m</span></p>
                                        <p>Mag Size: <span>{charOffHand.currentAmmo} / {charOffHand.magSize}</span></p>
                                    </div>
                                }
                            </div>
                            <div className="weapButContainer">
                                {(charOffHand.type !== "Blade" && charOffHand.type !== "Blunt" && charOffHand.currentAmmo < charOffHand.magSize)  &&
                                    <div className="bg-med1">RELOAD</div>
                                }
                                <div className="bg-med2" onClick={openOffhandAttackModal}>ATTACK</div>
                                
                            </div>
                        </div>
                    </div>
                ) : offHandAttackType === "Unarmed" && (
                    <div className="weaponListItem">
                        <div className="hand">Gloves</div>
                        <div className="equipContainer">
                            <h2>{charGloves.name}</h2>
                            <div>
                                <p>Num Dice: <span>{charGloves.numDice}</span></p>
                                <p>Dice Size: <span>d{charGloves.diceSize}</span></p>
                            </div>
                            <div className="weapButContainer">
                                <div className="bg-med2" onClick={openOffhandAttackModal}>ATTACK</div>
                            </div>
                        </div>
                    </div>
                )
                }

                {vehicleWeap1 !== undefined &&
                    <div className="weaponListItem">
                        <div className="hand">Vehicle Weapon 1</div>
                        <div className="equipContainer">
                            <h2>{vehicleWeap1.name}</h2>
                            <div>
                                <p>Num Dice: <span>{vehicleWeap1.numDice}</span></p>
                                <p>Dice Size: <span>d{vehicleWeap1.diceSize}</span></p>
                            </div>
                            <div>
                                {(vehicleWeap1.type !== "Blade" && vehicleWeap1.type !== "Blunt") &&
                                    <div>
                                        <p>Range: <span>{vehicleWeap1.range}m</span></p>
                                        <p>Mag Size: <span>{vehicleWeap1.currentAmmo} / {vehicleWeap1.magSize}</span></p>
                                    </div>
                                }
                            </div>
                            <div className="weapButContainer">
                                {(vehicleWeap1.type !== "Blade" && vehicleWeap1.type !== "Blunt" && vehicleWeap1.currentAmmo < vehicleWeap1.magSize)  &&
                                    <div className="bg-med1">RELOAD</div>
                                }
                                <div className="bg-med2" onClick={openVehicleAttackModal1}>ATTACK</div>
                            </div>
                        </div>
                    </div>
                }

                {vehicleWeap2 !== undefined &&
                    <div className="weaponListItem">
                        <div className="hand">Vehicle Weapon 2</div>
                        <div className="equipContainer">
                            <h2>{vehicleWeap2.name}</h2>
                            <div>
                                <p>Num Dice: <span>{vehicleWeap2.numDice}</span></p>
                                <p>Dice Size: <span>d{vehicleWeap2.diceSize}</span></p>
                            </div>
                            <div>
                                {(vehicleWeap2.type !== "Blade" && vehicleWeap2.type !== "Blunt") &&
                                    <div>
                                        <p>Range: <span>{vehicleWeap2.range}m</span></p>
                                        <p>Mag Size: <span>{vehicleWeap2.currentAmmo} / {vehicleWeap2.magSize}</span></p>
                                    </div>
                                }
                            </div>
                            <div className="weapButContainer">
                                {(vehicleWeap2.type !== "Blade" && vehicleWeap2.type !== "Blunt" && vehicleWeap2.currentAmmo < vehicleWeap2.magSize)  &&
                                    <div className="bg-med1">RELOAD</div>
                                }
                                <div className="bg-med2" onClick={openVehicleAttackModal2}>ATTACK</div>
                            </div>
                        </div>
                    </div>
                }

                <h2 className='mary-1'>OTHER ACTIONS</h2>
                <h1>MAJOR</h1>
                {allActions.map((action) => action.type === "Major" && (
                    <div className="action-container" key={action.name}>
                        <p className="action-name">{action.name}</p>
                        <p className="action-desc">{action.desc}</p>
                    </div>
                ))}
                <h1>MINOR</h1>
                {allActions.map((action) => action.type === "Minor" && (
                    <div className="action-container" key={action.name}>
                        <p className="action-name">{action.name}</p>
                        <p className="action-desc">{action.desc}</p>
                    </div>
                ))}
                
                <h1>MOVEMENT</h1>
                {allActions.map((action) => action.type === "Movement" && (
                    <div className="action-container" key={action.name}>
                        <p className="action-name">{action.name}</p>
                        <p className="action-desc">{action.desc}</p>
                    </div>
                ))}
                <h1>NON-COMBAT</h1>
                {allActions.map((action) => action.type === "Non-Combat" && (
                    <div className="action-container" key={action.name}>
                        <p className="action-name">{action.name}</p>
                        <p className="action-desc">{action.desc}</p>
                    </div>
                ))}
                <h1>BONUS</h1>
                {allActions.map((action) => action.type === "Bonus" && (
                    <div className="action-container" key={action.name}>
                        <p className="action-name">{action.name}</p>
                        <p className="action-desc">{action.desc}</p>
                    </div>
                ))}
            </div>
        </Fragment>
    );
};

CharEditActions.propTypes = {
    character: PropTypes.object.isRequired,
    saveCharacter: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    character: state.character
});

export default connect(mapStateToProps, {saveCharacter})(CharEditActions);
